// src/components/admin/page-management/GeneralTab.js - update this component
import React from "react";
import BackgroundManager from "./BackgroundManager";

const GeneralTab = ({
  formData,
  handleInputChange,
  generateSlug,
  onSubmit,
  handleBackgroundUpdate,
  pageSlug,
}) => {
  return (
    <div className="space-y-6">
      <form onSubmit={onSubmit}>
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Title</label>
          <input
            type="text"
            name="title"
            className="w-full p-2 border rounded"
            value={formData.title}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">
            Slug
            <button
              type="button"
              onClick={generateSlug}
              style={{ boxShadow: "none", transform: "none" }}
              className="ml-2 text-blue-500 text-xs hover:underline"
            >
              Generate from title
            </button>
          </label>
          <input
            type="text"
            name="slug"
            className="w-full p-2 border rounded"
            value={formData.slug}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Description</label>
          <textarea
            name="description"
            className="w-full p-2 border rounded"
            rows="3"
            value={formData.description}
            onChange={handleInputChange}
          ></textarea>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Template</label>
          <select
            name="template"
            className="w-full p-2 border rounded"
            value={formData.template}
            onChange={handleInputChange}
          >
            <option value="default">Default</option>
            <option value="full-width">Full Width</option>
            <option value="sidebar">With Sidebar</option>
            <option value="landing">Landing Page</option>
          </select>
        </div>

        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="isPublished"
              className="mr-2"
              checked={formData.isPublished}
              onChange={handleInputChange}
            />
            <span className="text-sm font-medium">Published</span>
          </label>
        </div>

        <button
          type="submit"
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
        >
          Save Changes
        </button>
      </form>

      {/* Add the Background Manager */}
      <div className="mt-8">
        <h3 className="text-lg font-medium mb-3">Page Background</h3>
        <BackgroundManager
          pageData={formData}
          onUpdate={handleBackgroundUpdate}
          pageSlug={pageSlug}
        />
      </div>
    </div>
  );
};

export default GeneralTab;

// // before background managemr
// // src/components/admin/page-management/GeneralTab.js
// import React from 'react';

// const GeneralTab = ({ formData, handleInputChange, generateSlug, onSubmit }) => {
//   return (
//     <form onSubmit={onSubmit}>
//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Title</label>
//         <input
//           type="text"
//           name="title"
//           className="w-full p-2 border rounded"
//           value={formData.title}
//           onChange={handleInputChange}
//           required
//         />
//       </div>

//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">
//           Slug
//           <button
//             type="button"
//             onClick={generateSlug}
//             style={{boxShadow:'none', transform:'none'}}
//             className="ml-2 text-blue-500 text-xs hover:underline"
//           >
//             Generate from title
//           </button>
//         </label>
//         <input
//           type="text"
//           name="slug"
//           className="w-full p-2 border rounded"
//           value={formData.slug}
//           onChange={handleInputChange}
//           required
//         />
//       </div>

//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Description</label>
//         <textarea
//           name="description"
//           className="w-full p-2 border rounded"
//           rows="3"
//           value={formData.description}
//           onChange={handleInputChange}
//         ></textarea>
//       </div>

//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Template</label>
//         <select
//           name="template"
//           className="w-full p-2 border rounded"
//           value={formData.template}
//           onChange={handleInputChange}
//         >
//           <option value="default">Default</option>
//           <option value="full-width">Full Width</option>
//           <option value="sidebar">With Sidebar</option>
//           <option value="landing">Landing Page</option>
//         </select>
//       </div>

//       <div className="mb-4">
//         <label className="flex items-center">
//           <input
//             type="checkbox"
//             name="isPublished"
//             className="mr-2"
//             checked={formData.isPublished}
//             onChange={handleInputChange}
//           />
//           <span className="text-sm font-medium">Published</span>
//         </label>
//       </div>

//       <button
//         type="submit"
//         className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
//       >
//         Save Changes
//       </button>
//     </form>
//   );
// };

// export default GeneralTab;
